__webpack_require__.p = "/rent2022/static/build/";